import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { TreeItemStatus } from '@core/enums/tree-item-status';
import { ApproveInspectionReportRequest } from '@core/interfaces/requests/approve-inspection-report-request';
import { RejectInspectionReportRequest } from '@core/interfaces/requests/reject-inspection-report-request';
import { UrlService } from '@core/services/url.service';
import { firstValueFrom } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class InspectionApprovalService {
  #urlService = inject(UrlService);
  #httpClient = inject(HttpClient);

  public rejectInspection(request: RejectInspectionReportRequest): Promise<void> {
    const url = this.#urlService.getUrl(`inspection-report-approvals/reject`);
    return firstValueFrom(this.#httpClient.post<void>(url, request));
  }

  public approveInspection(request: ApproveInspectionReportRequest): Promise<void> {
    const url = this.#urlService.getUrl(`inspection-report-approvals/approve`);
    return firstValueFrom(this.#httpClient.post<void>(url, request));
  }

  public completeInspectionAfterApproval(projectId: string, taskId: string) {
    const url = this.#urlService.getUrl(`tasks/${taskId}/send`);
    return firstValueFrom<void>(this.#httpClient.post<void>(url, null));
  }

  public complete(projectId: string, jobId: string, taskId: string) {
    const url = this.#urlService.getUrl(`hubs/${projectId}/jobs/${jobId}/tasks/${taskId}/status`);
    return this.#httpClient.put(url, { status: TreeItemStatus.Completed });
  }
}
